import React from 'react';
import { Checkbox, Form } from 'antd';
import './CustomerCheckInput.scss';

function CustomerCheckInput({
  label, name, className, errorMessage, defaultChecked,
}) {
  return (
    <Form.Item className={`customer-check-input ${className}`} name={name} validateStatus={errorMessage && 'error'} help={errorMessage} valuePropName="checked">
      <div className="flex justify-content items-center p-[14px] check-wrapper">
        <Checkbox defaultChecked={defaultChecked}>{label}</Checkbox>
      </div>
    </Form.Item>
  );
}

export default CustomerCheckInput;
